export class UiUtils {

  static convertLineColourCodeToClassString(code: number | never, storeId: string, cssClass: string): string {
    const colourCode = typeof code === 'number' ? code : 0;
    return `${cssClass}${storeId}-${colourCode}`;
  }

}
